import $ from "jquery";
import { course } from "./course";
import { dataaccess } from "../dataaccess/dataContext";
import { forms } from "../framework/forms";
import { dateFormatter } from "../framework/dateFormatter";

function init() {
    $(document).on("click", ".js-coi-modal", function() {
        const $btn = $(this);
        const disclosureId = $btn.data("id");
        const programId = $btn.data("programid");
        const isReadOnly = $btn.data("readonly");
        $("#CoiModal").modal("show");

        dataaccess
            .get({
                url:
                    `/CourseRoster/ConflictOfInterest?disclosureId=${disclosureId}&programId=${programId}`
            })
            .done(function(result) {
                $("#CoiModal .modal-body").html(result);

                if (isReadOnly) {
                    $("#CoiForm").find("button, input").prop("disabled", true);
                } else {
                    dateFormatter.initDatePicker();
                }
            });
    });

    $(document).on("submit", "#CoiForm", function(e) {
        e.preventDefault();
        const $form = $(this);
        $.validator.unobtrusive.parse("#CoiForm");

        if ($form.valid()) {
            forms.showSpinner("Saving...", false);

            const params = {
                "contentType": dataaccess.contentType.APPLICATION_X_WWW_FORM_URLENCODED,
                "data": $form.serialize(),
                "url": $form.attr("action")
            };

            dataaccess.post(params)
                .fail(function(xhr, status, error) {
                    if (xhr.status === 400 && xhr.responseText !== "") {
                        $("#CoiModal .modal-body").html(xhr.responseText);
                        dateFormatter.initDatePicker();
                    }
                })
                .done(function() {
                    $("#CoiModal").modal("hide");
                    course.populateFacultyTable();
                })
                .always(function() {
                    forms.hideSpinner();
                });
        }
    });
}

export const conflictOfInterest = {
    init: init
};